// the includes method is part of es6, so we have to polyfill untill we have browser support

if (!String.prototype.includes) {
    String.prototype.includes = function () {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

/*
  IE Doesn't have a .startsWith
*/
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (str){
    return this.lastIndexOf(str, 0) === 0;
  };
}



/** WEBPACK FOOTER **
 ** ./Scripts/Polyfills/includes.js
 **/